import { createApi } from '@reduxjs/toolkit/query/react';
import { userAxiosQuery } from '../../utils/axios/user.axios';
import { IPage } from '../../interfaces/models/models/paginated-response.model';

export interface MarketingTableRow {
    id: string;
    email: string;
    fullName: string;
    company: string;
    reportDownloaded: string;
    reportName: string;
    createdAt: string;
}

type MarketingReportType = 'report' | 'demo';

interface MarketingReportsQueryArgs {
    search?: string;
    type: MarketingReportType;
    pageNumber?: number;
    pageSize?: number;
    startDate?: string;
    endDate?: string;
}

export const marketingApi = createApi({
    reducerPath: 'marketing',
    baseQuery: userAxiosQuery(),
    endpoints: (builder) => ({
        getMarketingReports: builder.query<
            { elements: MarketingTableRow[]; page?: IPage },
            MarketingReportsQueryArgs
        >({
            query: ({ search, type, pageNumber, pageSize, startDate, endDate }) => {
                const params = new URLSearchParams();
                params.set('type', type);
                if (search) {
                    params.set('search', search);
                }
                if (pageNumber) {
                    params.set('page', String(pageNumber));
                }
                if (pageSize) {
                    params.set('size', String(pageSize));
                }
                if (startDate) {
                    params.set('startDate', startDate);
                }
                if (endDate) {
                    params.set('endDate', endDate);
                }

                return {
                    url: `/demo-requests/reports?${params.toString()}`,
                    method: 'GET',
                };
            },
            transformResponse: (response: any) => {
                const payload = response?.data ?? response;
                const rawElements = payload?.elements ?? [];
                const elements: MarketingTableRow[] = rawElements.map(
                    (el: any): MarketingTableRow => ({
                        id: el._id,
                        email: el.businessEmail,
                        fullName: [el.firstName, el.lastName]
                            .filter(Boolean)
                            .join(' '),
                        company: el.hotelName,
                        reportDownloaded: el.type,
                        reportName: el.reportName,
                        createdAt: el.createdAt,
                    }),
                );

                return {
                    elements,
                    page: payload?.page as IPage | undefined,
                };
            },
        }),
    }),
});

export const {
    useGetMarketingReportsQuery,
    useLazyGetMarketingReportsQuery,
} = marketingApi;

